import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to="/" className="navbar-logo-link" onClick={closeMobileMenu}>
          <img
            src="/ec_logo_white.png"
            alt="TDS Event Center"
            className="navbar-logo"
          />
        </Link>
      </div>
      
      {/* Mobile Menu Button */}
      <button 
        className="mobile-menu-toggle"
        onClick={toggleMobileMenu}
        aria-label="Toggle menu"
      >
        <span className={`hamburger ${mobileMenuOpen ? 'active' : ''}`}>
          <span></span>
          <span></span>
          <span></span>
        </span>
      </button>

      {/* Desktop Menu */}
      <div className="navbar-menu desktop-menu">
        <div className="navbar-links">
          <Link to="/calendar" className="nav-link">Calendar</Link>
          <Link to="/services" className="nav-link">Services</Link>
          <Link to="/sponsors" className="nav-link">Sponsors</Link>
          {/* <Link to="/game" className="nav-link">Game</Link> */}
          <Link to="/team200" className="nav-link">Team 200</Link>
        </div>
        <a
          className="contact-button contact-button-primary navbar-donate"
          href="https://secure.qgiv.com/for/friendsofthefair-communitybuilding/?utm_id=97758_v0_s00_e0_tv2_a1den1nmxgth1u"
        >
          Donate
        </a>
      </div>

      {/* Mobile Menu Overlay */}
      {mobileMenuOpen && (
        <div className="mobile-menu-overlay" onClick={closeMobileMenu}></div>
      )}

      {/* Mobile Menu */}
      <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
        <div className="mobile-menu-content">
          <Link to="/calendar" className="mobile-nav-link" onClick={closeMobileMenu}>
            Calendar
          </Link>
          <Link to="/services" className="mobile-nav-link" onClick={closeMobileMenu}>
            Services
          </Link>
          <Link to="/sponsors" className="mobile-nav-link" onClick={closeMobileMenu}>
            Sponsors
          </Link>
          {/* <Link to="/game" className="mobile-nav-link" onClick={closeMobileMenu}>
            Game
          </Link> */}
          <Link to="/team200" className="mobile-nav-link" onClick={closeMobileMenu}>
            Team 200
          </Link>
          <a
            href="https://secure.qgiv.com/for/friendsofthefair-communitybuilding/?utm_id=97758_v0_s00_e0_tv2_a1den1nmxgth1u"
            className="mobile-nav-link mobile-donate"
            onClick={closeMobileMenu}
          >
            Donate
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
